export type { FeaturedAndSortedPortalsState } from './reducer';
export { featuredAndSortedPortalsReducer } from './reducer';
